/* Zermira sonsuz kaydırma: <zr-infinite data-next data-section> */
if (!customElements.get('zr-infinite')) {
  customElements.define('zr-infinite', class extends HTMLElement {
    connectedCallback() {
      this.loading = false;
      this.btn = this.querySelector('[data-zr-more]');
      this.spin = this.querySelector('.zr-inf__spin');
      if (!this.dataset.next) return;
      this.btn && this.btn.addEventListener('click', (e) => { e.preventDefault(); this.load(); });
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((en) => { if (en[0].isIntersecting) this.load(); }, { rootMargin: '0px 0px 900px 0px' });
        this.io.observe(this);
      }
    }
    disconnectedCallback() { this.io && this.io.disconnect(); }
    grid() {
      const sec = this.closest('.shopify-section') || document;
      return sec.querySelector('#product-grid') || document.querySelector('#product-grid');
    }
    load() {
      const next = this.dataset.next;
      if (!next || this.loading) return;
      this.loading = true;
      if (this.btn) this.btn.hidden = true;
      if (this.spin) this.spin.hidden = false;
      const url = next + (next.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(this.dataset.section);
      fetch(url).then((r) => r.text()).then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = doc.querySelectorAll('#product-grid > .grid__item');
        const grid = this.grid();
        const frag = document.createDocumentFragment();
        items.forEach((li) => { li.classList.remove('scroll-trigger', 'animate--slide-in'); li.classList.add('zr-inf__new'); frag.appendChild(document.importNode(li, true)); });
        grid && grid.appendChild(frag);
        const nx = doc.querySelector('zr-infinite');
        const shown = nx ? nx.dataset.shown : this.dataset.total;
        this.dataset.shown = shown;
        const s = this.querySelector('[data-zr-shown]'); if (s) s.textContent = shown;
        const bar = this.querySelector('.zr-inf__bar span'); if (bar) bar.style.width = Math.min(100, (shown / this.dataset.total) * 100) + '%';
        if (nx && nx.dataset.next) { this.dataset.next = nx.dataset.next; if (this.btn) { this.btn.href = nx.dataset.next; this.btn.hidden = false; } }
        else { delete this.dataset.next; this.io && this.io.disconnect(); if (this.btn) this.btn.remove(); this.classList.add('is-done'); }
        document.dispatchEvent(new CustomEvent('zr:infinite-loaded', { detail: { count: items.length } }));
      }).catch(() => { if (this.btn) { this.btn.hidden = false; } })
        .finally(() => { this.loading = false; if (this.spin) this.spin.hidden = true;
          /* gözlemci hâlâ görünür durumdaysa (kısa sayfa) bir sonrakini de yükle */
          if (this.dataset.next && this.getBoundingClientRect().top < window.innerHeight + 900) setTimeout(() => this.load(), 60);
        });
    }
  });
}
